import { twMerge } from 'tailwind-merge';
import { Alert as MuiAlert } from '@mui/material';

import { AlertProps, AlertPropsWithToast } from './types';

export const Alert = ({ data }: AlertPropsWithToast) => {
  const { title, options } = data;

  return (
    <MuiAlert
      {...options}
      className={twMerge('inline-flex w-full rounded-2xl', options.className)}
    >
      {title}
    </MuiAlert>
  );
};

export type { AlertProps };
